module.exports = __webpack_public_path__ + "img/pw.9e793084.svg";